import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-text-filter-item',
    template: ` <ng-content></ng-content>`,
    host: {
        class: 'cmps-text-filter-item',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class TextFilterItemComponent {}
